import {createContext} from 'react'

import PropTypes from 'prop-types'

import {useMessagingReducer} from './useMessagingReducer/index.js'

const MessagingContext = createContext()

const MessagingProvider = ({children}) => {
  const value = useMessagingReducer()

  return <MessagingContext.Provider value={value}>{children}</MessagingContext.Provider>
}

MessagingProvider.displayName = 'MessagingProvider'
MessagingProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export {MessagingContext, MessagingProvider}
